import { Button, Form, Tabs } from 'antd';
import TextInput from '../inputs/TextInput';
import translations from '../../hooks/translation/translations.json';
import TabErrorControl from '../../inputs/TabErrorControl';
import FileInput from '../inputs/FileInput';

function BannerForm({
  form,
  errors,
  handleSubmit,
  loading = false,
}) {
  const validateFile = (rule, value) => {
    const file = value?.fileList?.[0];

    if (!file) {
      return Promise.resolve();
    }

    const isLt10M = file.size / 1024 / 1024 > 10;
    if (isLt10M) {
      return Promise.reject(translations.ka.max_10mb);
    }

    return Promise.resolve();
  };

  const items = [
    {
      label: TabErrorControl(errors, 'georgian', '_ka'),
      key: '1',
      forceRender: true,
      children: (
        <>
          <TextInput
            label={`${translations.ka.title}*`}
            errorMessage={errors?.title_ka}
            name="title_ka"
          />
          <TextInput
            label={`${translations.ka.subtitle}*`}
            errorMessage={errors?.subtitle_ka}
            name="subtitle_ka"
          />
          <FileInput
            name="banner_image_ka"
            label={`${translations.ka.image}*`}
            errorMessage={errors?.banner_image_ka}
            accept=".png, .jpg, .gif"
            rules={[{
              validator: validateFile,
            }]}
            form={form}
          />
          <TextInput
            label={`${translations.ka.link}*`}
            errorMessage={errors?.link_ka}
            name="link_ka"
          />
        </>
      ),
    },
    {
      label: TabErrorControl(errors, 'english', '_en'),
      key: '2',
      forceRender: true,
      children: (
        <>
          <TextInput
            label={`${translations.ka.title}*`}
            errorMessage={errors?.title_en}
            name="title_en"
          />
          <TextInput
            label={`${translations.ka.subtitle}*`}
            errorMessage={errors?.subtitle_en}
            name="subtitle_en"
          />
          <FileInput
            name="banner_image_en"
            label={`${translations.ka.image}*`}
            errorMessage={errors?.banner_image_en}
            accept=".png, .jpg"
            rules={[{
              validator: validateFile,
            }]}
            form={form}
          />
          <TextInput
            label={`${translations.ka.link}*`}
            errorMessage={errors?.link_en}
            name="link_en"
          />
        </>
      ),
    },
    {
      label: TabErrorControl(errors, 'russian', '_ru'),
      key: '3',
      forceRender: true,
      children: (
        <>
          <TextInput
            label={`${translations.ka.title}*`}
            errorMessage={errors?.title_ru}
            name="title_ru"
          />
          <TextInput
            label={`${translations.ka.subtitle}*`}
            errorMessage={errors?.subtitle_ru}
            name="subtitle_ru"
          />
          <FileInput
            name="banner_image_ru"
            label={`${translations.ka.image}*`}
            errorMessage={errors?.banner_image_ru}
            accept=".png, .jpg"
            rules={[{
              validator: validateFile,
            }]}
            form={form}
          />
          <TextInput
            label={`${translations.ka.link}*`}
            errorMessage={errors?.link_ru}
            name="link_ru"
          />
        </>
      ),
    },
  ];
  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
    >
      <Tabs
        defaultActiveKey="1"
        items={items}
      />
      <Form.Item>
        <Button
          loading={loading}
          type="primary"
          htmlType="submit"
        >
          {translations.ka.submit}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default BannerForm;
